import Enum from "../../../enums/Enum";

const EnumIdType = new Enum({
    ID: {name: "ID"},
    PASSPORT: {name: "Passport"},
    DRIVER_LICENSE: {name: "Driver's License"},
    OTHER: {name: "Other"}
});

export default EnumIdType;